import {Injectable} from "@angular/core";
import { CustomOAuthService } from 'src/service/custom-oauth-service';

@Injectable()
export class CheckPermission {

  constructor(private oauthService: CustomOAuthService) {
  }

  isSuperuser(): boolean {
    let regra = this.givenAuthorities() || [];
    // console.log(regra);
    return regra.find(role => role.authority === 'ROLE_SUPER') !== undefined;
  }

  isAccountant(): boolean {
    let regra = this.givenAuthorities();
    return regra.find(role => role.authority === 'ROLE_ACCOUNTANT_ADMIN') !== undefined ||
           regra.find(role => role.authority === 'ROLE_ACCOUNTANT_COLLABORATOR') !== undefined;
  }

  isAccountantAdmin(): boolean{
    let regra = this.givenAuthorities();
    return regra.find(role => role.authority === 'ROLE_ACCOUNTANT_ADMIN') !== undefined;
  }

  isAccountantCollaborator(): boolean {
    let regra = this.givenAuthorities();
    return regra.find(role => role.authority === 'ROLE_ACCOUNTANT_COLLABORATOR') !== undefined;
  }

  isFarmer(): boolean {
    let regra = this.givenAuthorities();
    return regra.find(role => role.authority === 'ROLE_FARMER_ADMIN') !== undefined ||
           regra.find(role => role.authority === 'ROLE_FARMER_COLLABORATOR') !== undefined;
  }

  isFarmerAdmin(): boolean {
    let regra = this.givenAuthorities();
    return regra.find(role => role.authority === 'ROLE_FARMER_ADMIN') !== undefined
  }

  isFarmerCollaborator(): boolean {
    let regra = this.givenAuthorities();
    return regra.find(role => role.authority === 'ROLE_FARMER_COLLABORATOR') !== undefined;
  }

  isConsultant(): boolean {
    let regra = this.givenAuthorities();
    return regra.find(role => role.authority === 'ROLE_CONSULTANT') !== undefined;
  }

  private givenAuthorities() {
    var claims = this.oauthService.getIdentityClaims();
    // console.log("claims: ",claims)

    if (!claims) return null;
    return claims['authorities'];
  }

  getRoles(): string[] {
    let regra = this.givenAuthorities();
    return regra.map(role => role.authority);
  }

}
